import axios from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';

export function home(params = {}, rest = {}) {
    return axios.get('/partner/home', { params, ...rest }).then(({ data }) => {
        if (data && typeof data === 'object' && data.meta && Array.isArray(data.destinations)) {
            return data;
        }
        throw new ApiRequestError('Failed home partners /partner/home', { params, rest });
    });
}

export function fetchById(id, rest = {}) {
    return axios.get(`/partner/${id}`, rest).then(({ data }) => {
        if (Array.isArray(data) && data[0]) {
            return data[0];
        }
        throw new ApiRequestError(`Failed fetchById partners /partner/${id}`, { id, rest });
    });
}

export function fetch(params = {}, rest = {}) {
    return axios.get('/partner', { params, ...rest }).then(({ data }) => {
        if (data && typeof data === 'object' && Array.isArray(data.items)) {
            return data;
        }
        throw new ApiRequestError('Failed fetch partners /partner', { params, rest });
    });
}
